/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import SamskritiCardColumn from '@components/Card/SamskritiCardColumn';
import SectionUI from '@components/UI/Common/SectionUI';
/* Styles */
/* Services */

/**
 * Renders Program Offered Component
 * @param {Object} sectionContent - Data of Section from api
 * @param {string} region - Region of the Section
 * @param {string} lang - Language of the Section
 * @returns {ReactElement} - Program Offered
 */
const BenefitsSection = ({ sectionContent, lang, region }) => {
  return (
    <Box p="40px 0" m="0 auto" minW={'1px'}>
      {sectionContent && sectionContent.length
        ? sectionContent.map(section => {
            if (section._modelApiKey === 'card_samskriti3_column_group') {
              return (
                <SamskritiCardColumn
                  key={nanoid(5)}
                  section={section}
                  region={region}
                  lang={lang}
                />
              );
            } else {
              return (
                <SectionUI
                  key={nanoid(4)}
                  sectionContent={section}
                  region={region}
                  language={lang}
                />
              );
            }
          })
        : null}
    </Box>
  );
};

export default BenefitsSection;
